export default "__VITE_ASSET__Bk_2A2Gi__"